export const JENIS_OPTS = [
  { value: "HARI_KERJA", label: "Hari Kerja" },
  { value: "LIBUR_MINGGUAN", label: "Libur Mingguan" },
  { value: "LIBUR_NASIONAL", label: "Libur Nasional" },
];
export const JENIS_LABEL = Object.fromEntries(JENIS_OPTS.map((o) => [o.value, o.label]));
export const STATUS_COLOR = {
  DIAJUKAN: "bg-amber-100 text-amber-700 border-amber-200",
  DISETUJUI: "bg-emerald-100 text-emerald-700 border-emerald-200",
  DIBAYARKAN: "bg-blue-100 text-blue-700 border-blue-200",
  DITOLAK: "bg-rose-100 text-rose-700 border-rose-200",
  DIARSIPKAN: "bg-slate-100 text-slate-600 border-slate-300",
  DIBATALKAN: "bg-slate-100 text-slate-400 border-slate-200 line-through",
};
export const BATAS_JAM_BULAN = 30;
export const rp = (n) => "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");

export function durasiJam(mulai, selesai, istirahat = 0) {
  const tomin = (s) => { const [h, m] = String(s || "0:0").replace(/[.,]/g, ":").split(":"); return ((+h) || 0) * 60 + (+m || 0); };
  let a = tomin(mulai), b = tomin(selesai);
  if (b <= a) b += 1440;
  return Math.max(0, Math.round(((b - a) / 60 - (Number(istirahat) || 0)) * 100) / 100);
}

// Baris efektif SPL: perorangan = baris; group = jam tiap pekerja (tanggal/jenis hari ikut baris pertama)
export function barisEfektifSPL(s) {
  const baris = s?.baris || [];
  if (s?.mode === "group" && baris.length && (s.pekerja || []).length) {
    const b0 = baris[0];
    return s.pekerja.map((p) => ({ ...b0, jam_mulai: p.jam_mulai ?? b0.jam_mulai, jam_selesai: p.jam_selesai ?? b0.jam_selesai, istirahat_jam: p.istirahat_jam ?? 0 }));
  }
  return baris;
}

export const totalJamSPL = (s) => Math.round(barisEfektifSPL(s).reduce((a, b) => a + durasiJam(b.jam_mulai, b.jam_selesai, b.istirahat_jam || 0), 0) * 100) / 100;

export function hitungLembur(jenis, jam, p, upahSebulan) {
  const uphr = p?.jam_per_bulan ? (Number(upahSebulan) || 0) / p.jam_per_bulan : 0;
  const rows = [];
  if (jenis === "HARI_KERJA") {
    if (jam > 0) rows.push([`${p.hk_1}× jam ke-1`, Math.min(jam, 1), p.hk_1]);
    if (jam > 1) rows.push([`${p.hk_2}× jam berikutnya`, Math.round((jam - 1) * 100) / 100, p.hk_2]);
  } else {
    const b1 = Number(p.hari_kerja_per_minggu) === 5 ? 8 : 7;
    if (jam > 0) rows.push([`${p.libur_a}× jam 1–${b1}`, Math.min(jam, b1), p.libur_a]);
    if (jam > b1) rows.push([`${p.libur_b}× jam ke-${b1 + 1}`, Math.min(jam - b1, 1), p.libur_b]);
    if (jam > b1 + 1) rows.push([`${p.libur_c}× jam ke-${b1 + 2}+`, Math.round((jam - b1 - 1) * 100) / 100, p.libur_c]);
  }
  const setara = Math.round(rows.reduce((s, [, j, m]) => s + j * m, 0) * 1000) / 1000;
  return { uphr, rows, setara, total: Math.round(setara * uphr) };
}

export function downloadBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
